module.exports = __webpack_public_path__ + "static/media/10-luciola-romulo.b489bcff.webp";